import React from 'react'
import { Grid, Typography } from '@mui/material'

import withStyles from '@mui/styles/withStyles'

import Avatar from 'components/molecules/avatar'

import QAPVars from 'qap/vars'
import type { User } from 'types'

type UserInfoProps = {
  classes: any;
  user: User;
};

const styles = (theme: any) => ({
  avatar: {
    paddingRight: theme.spacing(1)
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },

  name: {
    fontWeight: 'bold'
  },

  email: {
    color: QAPVars.pdfBGGray
  },
})

const UserInfo = ({
  classes,
  user,
}: UserInfoProps) => {
  const { firstName = '', lastName = '', email = '' } = user
  const userName = `${firstName} ${lastName}`

  return (
    <Grid container>
      <Grid item className={classes.avatar}>
        <Avatar user={user} />
      </Grid>
      <Grid item className={classes.textContainer}>
        <Typography className={classes.name}>{ userName }</Typography>
        <Typography className={classes.email}>{ email }</Typography>
      </Grid>
    </Grid>
  )
}

// @ts-expect-error - TS2345 - Argument of type '(theme: any) => { avatar: { paddingRight: any; }; textContainer: { display: string; flexDirection: string; justifyContent: string; }; name: { fontWeight: string; }; email: { color: string; }; }' is not assignable to parameter of type 'Styles<any, any, string>'.
export default withStyles(styles)(UserInfo)
